import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionStoreRepository } from "../../shared/repositories/session.repository";
import { LoadingSpinnerGrowComponent } from "../../shared/components/loading/loading-spinner-grow/loading-spinner-grow.component";
import { CommonModule } from "@angular/common";
import { LoginResult } from "../../shared/models/auth.model";
import { TranslocoDirective } from "@jsverse/transloco";
import * as bootstrap from "bootstrap";

@Component({
    selector: "web-patient-signin",
    templateUrl: "./signin.component.html",
    styleUrls: ["./signin.component.scss"],
    imports: [LoadingSpinnerGrowComponent, CommonModule, TranslocoDirective]
})
export class SigninComponent implements OnInit {
    loginIsError = false;
    schemaAccessResult: boolean | null = null;
    schemaId: number | null = null;
    private schemaAccessResultDialog: bootstrap.Modal | undefined;
    private navigateToSchemaOnClose = false;

    constructor(
        private readonly sessionService: SessionStoreRepository,
        private readonly route: ActivatedRoute,
        private readonly router: Router
    ) { }

    ngOnInit(): void {
        const code = this.route.snapshot.queryParamMap.get("code");
        const schemaAccessKey = this.sessionService.popSchemaAccessKey();

        if (!this.sessionService.isLoggedIn()) {
            if (code) {
                this.sessionService.login$(code, schemaAccessKey).subscribe({
                    next: (loginResult: LoginResult) => {
                        if (loginResult) {
                            if (loginResult.schemaAccessResult === true || loginResult.schemaAccessResult === false) {
                                this.schemaAccessResult = loginResult.schemaAccessResult;
                                this.schemaId = loginResult.schemaId ?? null;
                                this.showSchemaAccessResultDialog();
                            } else {
                                this.handleRedirectOnLogin();
                            }
                        }
                    },
                    error: (message) => {
                        if (message.error) {
                            if (schemaAccessKey) {
                                this.sessionService.storeSchemaAccessKey(schemaAccessKey);
                            }
                            this.sessionService.redirectToStsValidateCprPage();
                        } else {
                            this.loginIsError = true;
                        }
                    },
                });
            } else {
                this.loginIsError = true;
            }
        } else {
            this.handleRedirectOnLogin();
        }
    }

    handleRedirectOnLogin() {
        setTimeout(() => {
            this.completeLoginRedirect();
        }, 2000);
    }

    onLoginRetryClick() {
        this.router.navigate(["/auth"]);
    }

    onOpenSchemaClick() {
        this.navigateToSchemaOnClose = true;
    }

    private showSchemaAccessResultDialog() {
        const dialogElement = document.getElementById("schemaAccessResultDialog") as HTMLElement;
        this.schemaAccessResultDialog = bootstrap.Modal.getOrCreateInstance(dialogElement);

        // Only navigate away once the user has acknowledged the result.
        dialogElement.addEventListener("hidden.bs.modal", () => {
            if (this.navigateToSchemaOnClose && this.schemaId) {
                sessionStorage.clear();
                this.router.navigate(["/schema", this.schemaId]);
            } else {
                this.completeLoginRedirect();
            }
        }, { once: true });

        this.schemaAccessResultDialog.show();
    }

    private completeLoginRedirect() {
        if (this.sessionService.isLoggedIn()) {
            sessionStorage.clear();
            this.router.navigate(["/authenticated"]);
        } else {
            this.router.navigate(["/welcome"]);
        }
    }
}
